export const logo = {
	black:
		"https://res.cloudinary.com/dfvx7yxrc/image/upload/v1733925145/Logo_iezszq.png",
	white:
		"https://res.cloudinary.com/dfvx7yxrc/image/upload/v1733925156/WhiteLogo_pyzdfp.png",
	// noText: "https://res.cloudinary.com/dfvx7yxrc/image/upload/v1739625811/image_1_q9doj8.png",
	noText: "https://res.cloudinary.com/dfvx7yxrc/image/upload/v1739636740/image_2_jg6mol.png",
};

export const heroImages = {
	home1:
		"https://res.cloudinary.com/dfvx7yxrc/image/upload/v1733925147/pen-hero_hyrj1r.jpg",
	home2:
		"https://res.cloudinary.com/dfvx7yxrc/image/upload/v1733925146/pen-hero1_rssbum.jpg",
	home3:
		"https://res.cloudinary.com/dfvx7yxrc/image/upload/v1733925147/pen-hero3_bcbv64.jpg",
	home4:
		"https://res.cloudinary.com/dfvx7yxrc/image/upload/v1733925147/pen-hero5_iujrgj.jpg",

	contactLg:
		"https://res.cloudinary.com/dfvx7yxrc/image/upload/v1733925688/contactLg_l56ntz.png",
	contactSm:
		"https://res.cloudinary.com/dfvx7yxrc/image/upload/v1733925688/contactMob_k2nkcf.png",

	HowItWorksLg:
		"https://res.cloudinary.com/dfvx7yxrc/image/upload/v1733925684/blogHeroLg_lbawng.png",
	HowItWorksSm:
		"https://res.cloudinary.com/dfvx7yxrc/image/upload/v1733925685/blogHeroMob_aecaud.png",
};

export const images = {
	supporthome:
		"https://res.cloudinary.com/dfvx7yxrc/image/upload/v1733925715/supporthome_czgqwm.png",
	refundmehome:
		"https://res.cloudinary.com/dfvx7yxrc/image/upload/v1733925712/refundmehome_trwgl0.png",
	kontribute:
		"https://res.cloudinary.com/dfvx7yxrc/image/upload/v1733925699/kontribute_qgfu0x.png",
	resources_download:
		"https://res.cloudinary.com/dfvx7yxrc/image/upload/v1739276423/focused-man-using-laptop-removebg-preview_imxen8.png",
	salary: "https://res.cloudinary.com/dfvx7yxrc/image/upload/v1742069071/Screenshot_2025-03-15_at_9.01.20_PM-removebg-preview_yjcek6.png",
	payment: "https://res.cloudinary.com/dfvx7yxrc/image/upload/v1742069249/pen-hero_hyrj1r-removebg-preview_z3iyjk.png",
	salaryPayment: "https://res.cloudinary.com/dfvx7yxrc/image/upload/v1742069787/image__1_-removebg-preview_uv6c4b.png",
};

export const PFALogos = [
	"https://res.cloudinary.com/dfvx7yxrc/image/upload/v1733925646/zenith_eqscjy.svg",
	"https://res.cloudinary.com/dfvx7yxrc/image/upload/v1733925645/veritas_ruin4d.jpg",
	"https://res.cloudinary.com/dfvx7yxrc/image/upload/v1733925644/uba_h88qlq.png",
	"https://res.cloudinary.com/dfvx7yxrc/image/upload/v1733925643/trustfund_mod6ij.png",
	"https://res.cloudinary.com/dfvx7yxrc/image/upload/v1733925642/stanbic_yx4sir.jpg",
	"https://res.cloudinary.com/dfvx7yxrc/image/upload/v1733925640/radix_qqraxv.png",
	"https://res.cloudinary.com/dfvx7yxrc/image/upload/v1733925639/premium_mxefh1.png",
	// "https://res.cloudinary.com/dfvx7yxrc/image/upload/v1733925638/pal_s0zfcq.png",
	"https://res.cloudinary.com/dfvx7yxrc/image/upload/v1733925637/oak_a3lpsa.png",
	"https://res.cloudinary.com/dfvx7yxrc/image/upload/v1733925637/nlpc_jbyosp.jpg",
	"https://res.cloudinary.com/dfvx7yxrc/image/upload/v1733925635/leadway_gjisyl.png",
	"https://res.cloudinary.com/dfvx7yxrc/image/upload/v1733925632/first_ja7rhi.jpg",
	"https://res.cloudinary.com/dfvx7yxrc/image/upload/v1733925632/fidelity_e410sy.png",
	"https://res.cloudinary.com/dfvx7yxrc/image/upload/v1733925631/fcmb_k5ltfi.png",
	"https://res.cloudinary.com/dfvx7yxrc/image/upload/v1733925631/crusader_clzz0x.png",
	"https://res.cloudinary.com/dfvx7yxrc/image/upload/v1733925628/access-arm_x2ejmq.png",
	"https://res.cloudinary.com/dfvx7yxrc/image/upload/v1735644281/GTPM_xlbldn.png",
	"https://res.cloudinary.com/dfvx7yxrc/image/upload/v1735644281/nupemco_eojgyd.jpg",
	"https://res.cloudinary.com/dfvx7yxrc/image/upload/v1735644282/npf_liwfdn.png",
	"https://res.cloudinary.com/dfvx7yxrc/image/upload/v1735644281/tangerine_w2nk9h.jpg",
	"https://res.cloudinary.com/dfvx7yxrc/image/upload/v1735644281/norrenberger_ntlhu0.png",
];

export const illustrations = {
	whyBg:
		"https://res.cloudinary.com/dfvx7yxrc/image/upload/v1733925724/whyBg_fpxi4f.jpg",
	why1: "https://res.cloudinary.com/dfvx7yxrc/image/upload/v1733925723/why1_uo7k8s.png",
	unauthCircles:
		"https://res.cloudinary.com/dfvx7yxrc/image/upload/v1733925717/unauth-circles_njgoz3.png",
	rightSphere:
		"https://res.cloudinary.com/dfvx7yxrc/image/upload/v1733925713/rightSphere_axpni0.png",
	personalCtaImg:
		"https://res.cloudinary.com/dfvx7yxrc/image/upload/v1733925703/personalctaimg_ijwqqm.png",
};

export const icons = {
	verifyEmail:
		"https://res.cloudinary.com/dfvx7yxrc/image/upload/v1733925722/verifyEmail_hmwrk5.png",
	userGroupBlack:
		"https://res.cloudinary.com/dfvx7yxrc/image/upload/v1733925721/userGroupBlack_uyvipw.png",
	userBlack:
		"https://res.cloudinary.com/dfvx7yxrc/image/upload/v1733925719/userBlack_n8bxri.png",
	twitter:
		"https://res.cloudinary.com/dfvx7yxrc/image/upload/v1733925717/twitter_navpih.png",
	rightArrow:
		"https://res.cloudinary.com/dfvx7yxrc/image/upload/v1733925712/rightArrow_war9gu.png",
	refundme:
		"https://res.cloudinary.com/dfvx7yxrc/image/upload/v1733925710/refundme_vwxnnk.png",
	refreshWhite:
		"https://res.cloudinary.com/dfvx7yxrc/image/upload/v1733925709/refresh-white_udwtcu.png",
	refresh:
		"https://res.cloudinary.com/dfvx7yxrc/image/upload/v1733925707/refresh_fuva1i.png",
	profile:
		"https://res.cloudinary.com/dfvx7yxrc/image/upload/v1733925706/profile_ljja3e.png",
	readTime:
		"https://res.cloudinary.com/dfvx7yxrc/image/upload/v1733925706/readTime_q8us7x.png",
	plus: "https://res.cloudinary.com/dfvx7yxrc/image/upload/v1733925703/plus_sr1xwu.png",
	Message:
		"https://res.cloudinary.com/dfvx7yxrc/image/upload/v1733925702/Message_i76fra.png",
	msgIcon:
		"https://res.cloudinary.com/dfvx7yxrc/image/upload/v1733925702/msgIcon_nqrckl.png",
	linked:
		"https://res.cloudinary.com/dfvx7yxrc/image/upload/v1733925700/linked_n_enbncd.png",
	instagram:
		"https://res.cloudinary.com/dfvx7yxrc/image/upload/v1733925698/instagram_bmvbdz.png",
	download:
		"https://res.cloudinary.com/dfvx7yxrc/image/upload/v1733925697/icons8-download-_xitivl.png",
	home: "https://res.cloudinary.com/dfvx7yxrc/image/upload/v1733925696/home_vansh1.png",
	goBackArr:
		"https://res.cloudinary.com/dfvx7yxrc/image/upload/v1733925695/goBackArr_phm8ud.png",
	feedback:
		"https://res.cloudinary.com/dfvx7yxrc/image/upload/v1733925693/feedback_gkcn4m.png",
	filterIcon:
		"https://res.cloudinary.com/dfvx7yxrc/image/upload/v1733925693/filter-icon_yzsb2a.svg",
	facebook:
		"https://res.cloudinary.com/dfvx7yxrc/image/upload/v1733925692/facebook_hnr6nn.png",
	emailIcon:
		"https://res.cloudinary.com/dfvx7yxrc/image/upload/v1733925691/emailIcon_bqfbgy.png",
	deleteWhite:
		"https://res.cloudinary.com/dfvx7yxrc/image/upload/v1733925690/deleteWhite_q9nmn6.png",
	createIcon:
		"https://res.cloudinary.com/dfvx7yxrc/image/upload/v1733925689/createIcon_qmy25w.png",
	contribute:
		"https://res.cloudinary.com/dfvx7yxrc/image/upload/v1733925688/contribute_hejq6w.png",
	close:
		"https://res.cloudinary.com/dfvx7yxrc/image/upload/v1733925687/close_eqam4z.png",
	callIcon:
		"https://res.cloudinary.com/dfvx7yxrc/image/upload/v1733925685/callIcon_pgo6tj.png",
	caret:
		"https://res.cloudinary.com/dfvx7yxrc/image/upload/v1733925685/caret_jup10q.png",
	bankCardIcon:
		"https://res.cloudinary.com/dfvx7yxrc/image/upload/v1733925683/bankCardIcon_bnw2rn.png",
	bank: "https://res.cloudinary.com/dfvx7yxrc/image/upload/v1733925682/bank_j28m6f.png",
	ArrowRightWhite:
		"https://res.cloudinary.com/dfvx7yxrc/image/upload/v1733925682/ArrowRightWhite_pbim9e.png",
	ajo: "https://res.cloudinary.com/dfvx7yxrc/image/upload/v1733925681/ajo_ppl984.png",
	nigeriaFlag:
		"https://res.cloudinary.com/dfvx7yxrc/image/upload/v1733925598/nigeriaFlag_rjnehw.svg",
	coilArrow:
		"https://res.cloudinary.com/dfvx7yxrc/image/upload/v1733925598/coilArrow_cynyie.svg",
	whatsapp:
		"https://res.cloudinary.com/dfvx7yxrc/image/upload/v1733925155/whatsapp_qe1kwy.png",
	verify:
		"https://res.cloudinary.com/dfvx7yxrc/image/upload/v1733925155/verify_inzx47.png",
	setupdd:
		"https://res.cloudinary.com/dfvx7yxrc/image/upload/v1733925155/setupdd_ei6in6.png",
	usergroup:
		"https://res.cloudinary.com/dfvx7yxrc/image/upload/v1733925155/usergroup_tcs6mt.png",
	send: "https://res.cloudinary.com/dfvx7yxrc/image/upload/v1733925155/send_azl9aa.png",
	saveWhite:
		"https://res.cloudinary.com/dfvx7yxrc/image/upload/v1733925155/saveWhite_xslyhh.png",
	overview:
		"https://res.cloudinary.com/dfvx7yxrc/image/upload/v1733925147/overview_nbt3wb.png",
	print:
		"https://res.cloudinary.com/dfvx7yxrc/image/upload/v1733925147/print_x4rhfu.png",
	profile2:
		"https://res.cloudinary.com/dfvx7yxrc/image/upload/v1733925147/profile_kmysr5.png",
	option:
		"https://res.cloudinary.com/dfvx7yxrc/image/upload/v1733925146/option_kwvh5k.png",
	nqr: "https://res.cloudinary.com/dfvx7yxrc/image/upload/v1733925146/nqr_tqsx0y.png",
	editIcon:
		"https://res.cloudinary.com/dfvx7yxrc/image/upload/v1733925146/edit-icon_sxymjv.png",
	edit: "https://res.cloudinary.com/dfvx7yxrc/image/upload/v1733925146/edit_zaqc5c.png",
	downloadWhite:
		"https://res.cloudinary.com/dfvx7yxrc/image/upload/v1733925146/download_zstsdv.png",
	down_arrow:
		"https://res.cloudinary.com/dfvx7yxrc/image/upload/v1733925146/down_arrow_pa9opg.png",
	menu: "https://res.cloudinary.com/dfvx7yxrc/image/upload/v1733925145/menu_cj3iab.png",
	loader:
		"https://res.cloudinary.com/dfvx7yxrc/image/upload/v1733925145/loader_naayjx.gif",
	creditcard:
		"https://res.cloudinary.com/dfvx7yxrc/image/upload/v1733925145/creditcard_p1bjpc.png",
	delete:
		"https://res.cloudinary.com/dfvx7yxrc/image/upload/v1733925145/delete_fkxchk.png",
	ddsetup:
		"https://res.cloudinary.com/dfvx7yxrc/image/upload/v1733925145/ddsetup_btuxvn.png",
	closeIcon:
		"https://res.cloudinary.com/dfvx7yxrc/image/upload/v1733925144/close-icon_xmevw5.svg",
	confirmpay:
		"https://res.cloudinary.com/dfvx7yxrc/image/upload/v1733925144/confirmpay_pmklo0.png",
	confirm:
		"https://res.cloudinary.com/dfvx7yxrc/image/upload/v1733925144/confirm_cs7glt.png",
	help: "https://res.cloudinary.com/dfvx7yxrc/image/upload/v1733925144/help_khgczk.png",
	closeNav:
		"https://res.cloudinary.com/dfvx7yxrc/image/upload/v1733925144/closeSNav_s6xnwj.png",
	feedbackBlack:
		"https://res.cloudinary.com/dfvx7yxrc/image/upload/v1733925144/feedbackBlack_q24ouf.png",
	business1:
		"https://res.cloudinary.com/dfvx7yxrc/image/upload/v1733925144/business1_ychawd.png",
	expense:
		"https://res.cloudinary.com/dfvx7yxrc/image/upload/v1733925144/expense_vps4po.png",
	closeIconBlack:
		"https://res.cloudinary.com/dfvx7yxrc/image/upload/v1733925143/close-icon_gnklq1.png",
	caretRight:
		"https://res.cloudinary.com/dfvx7yxrc/image/upload/v1733925143/caret-right_ci9vcb.png",
	bankGrey:
		"https://res.cloudinary.com/dfvx7yxrc/image/upload/v1733925143/bank_qbfgol.png",
	copyicon:
		"https://res.cloudinary.com/dfvx7yxrc/image/upload/v1734364223/copyicon_q3vrkb.png",
	checkMark:
		"https://res.cloudinary.com/dfvx7yxrc/image/upload/v1734364502/check-mark_nbzbt6.svg",
	sheets: "https://res.cloudinary.com/dfvx7yxrc/image/upload/v1742107345/microsoft-office-7040220_640_hwe40i.png"
};

export const documents = {
	beneficiaries_template:
		"https://res.cloudinary.com/dfvx7yxrc/raw/upload/v1786119378/verified_schedule_template_dietwb_uh3jhg.xlsx",
	employees_template:
		"https://res.cloudinary.com/dfvx7yxrc/raw/upload/v1740418825/employees_s38s9a.xlsx",
	privacy_doc:
		"https://drive.google.com/file/d/18d1wZUpIJQqSGrNlRSctIzEv4G_eZEK9/view?usp=drive_link",
	user_manual:
		"https://drive.google.com/file/d/12Duiey3gHqSXvAssdtUk_KpLQJ2JOZRh/view?usp=drive_link",
	sample_mandate: 
		"https://res.cloudinary.com/dfvx7yxrc/raw/upload/v1738615791/FILLED_SAMPLE_MANDATE_LETTER_PAYTHRU-PENSPHERE_eaflnl.docx",
	salary_mandate: 
		"https://res.cloudinary.com/dfvx7yxrc/raw/upload/v1741202609/FILLED_SAMPLE_MANDATE_LETTER_PAYTHRU-PENSPHERE_i5ktby.docx"
};
